import React, { useState, useEffect, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { Calendar } from "primereact/calendar";
import { set } from "date-fns";
import { parse, isAfter, isBefore, addDays, subDays } from "date-fns";

export const CambioSalario = ({ Auth }) => {
  const { selectedNomina } = useOutletContext();
  const navigate = useNavigate();
  const toast = useRef(null);
  const [empleados, setEmpleados] = useState([]);
  const [valorNumerico, setValorNumerico] = useState(null);
  const [salarioSolicitado, setSalarioSolicitado] = useState("");
  const [empleado, setEmpleado] = useState(null);
  // const [errMsg, setErrMsg] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [show, setShow] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const { idRegistro } = useParams();
  const [fechaInicial, setFechaInicial] = useState(null);
  const [fechaFinal, setFechaFinal] = useState(null);
  const [configSistema, setConfigSistema] = useState(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await axiosPrivate.get("/NOM/configuracion/sistema");
        setConfigSistema(res.data);
      } catch (err) {
        console.error("Error al obtener configuración", err);
      }
    };

    fetchConfig();
  }, []);
  const handleBack = () => {
    navigate(-1);
  };
  useEffect(() => {
    if (!selectedNomina || !configSistema) return;

    const config = configSistema["cambios Salario"];
    if (!config) return true;

    const fechaInicio = parse(
      selectedNomina.FechaInicial,
      "dd/MM/yyyy",
      new Date()
    );
    const fechaFin = parse(selectedNomina.FechaFinal, "dd/MM/yyyy", new Date());

    let min = fechaInicio;
    let max = fechaFin;

    switch (config.validacionFechas) {
      case "mes":
        min = new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), 1);
        max = new Date(
          fechaInicio.getFullYear(),
          fechaInicio.getMonth() + 1,
          0
        );
        break;
      case "personalizado":
        if (config.rango?.inicio) min = new Date(config.rango.inicio);
        if (config.rango?.fin) max = new Date(config.rango.fin);
        break;
      default:
        // No changes to min and max if the value is not recognized
        break;
    }

    setFechaInicial(min);
    setFechaFinal(max);
  }, [selectedNomina, configSistema]);

  const validarFechaModulo = (modulo, fecha) => {
    if (!selectedNomina || !configSistema || !fecha) return true;

    const config = configSistema[modulo];
    if (!config) return true;

    const fechaInicio = parse(
      selectedNomina.FechaInicial,
      "dd/MM/yyyy",
      new Date()
    );
    const fechaFin = parse(selectedNomina.FechaFinal, "dd/MM/yyyy", new Date());

    let min = fechaInicio;
    let max = fechaFin;

    switch (config.validacionFechas) {
      case "mes":
        min = new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), 1);
        max = new Date(
          fechaInicio.getFullYear(),
          fechaInicio.getMonth() + 1,
          0
        );
        break;
      case "personalizado":
        if (config.rango?.inicio) min = new Date(config.rango.inicio);
        if (config.rango?.fin) max = new Date(config.rango.fin);
        break;
      default:
        // No changes to min and max if the value is not recognized
        break;
    }

    const captura = config.capturaDias;
    if (captura) {
      if (captura.tipo === "primeros") {
        const nuevaMax = new Date(min);
        nuevaMax.setDate(nuevaMax.getDate() + captura.cantidad - 1);
        if (nuevaMax < max) max = nuevaMax;
      } else if (captura.tipo === "ultimos") {
        const nuevaMin = new Date(max);
        nuevaMin.setDate(nuevaMin.getDate() - captura.cantidad + 1);
        if (nuevaMin > min) min = nuevaMin;
      } else if (captura.tipo === "personalizado") {
        if (captura.rango?.inicio) min = new Date(captura.rango.inicio);
        if (captura.rango?.fin) max = new Date(captura.rango.fin);
      }
    }
    console.log(
      "Validando fecha:",
      fechaInicial,
      fechaFinal,
      "para el módulo:",
      modulo
    );
    return fecha >= min && fecha <= max;
  };

  const getData = async () => {
    if (!selectedNomina) return;
    const resEmpleados = await axiosPrivate.get(
      `/NOM/empleados/Select/${selectedNomina.idNomina}`
    );
    setEmpleados(resEmpleados.data);
  };

  // useEffect(() => {
  //   // setErrMsg("");
  // }, [empleado]);

  useEffect(() => {
    if (!selectedNomina) return;
    getData();
  }, [selectedNomina]);

  useEffect(() => {
    const fetchFalta = async () => {
      if (idRegistro) {
        try {
          const response = await axiosPrivate.get(
            `/NOM/cambio-salario/${idRegistro}`
          );
          console.log("CambioSalarioResponse:", response.data);
          if (!response.data) return;
          console.log("response.data:", response.data);
          const { numero, salarioSolicitado, observaciones, fechaAplicacion } =
            response.data;
          console.log("numero:", numero);
          console.log("empleados:", empleados);
          setObservaciones(observaciones || "");
          //setSalarioSolicitado(salarioSolicitado || "");
          setFechaAplicacion(
            fechaAplicacion ? new Date(fechaAplicacion) : null
          );
          if (!isNaN(salarioSolicitado)) {
            setValorNumerico(Number(salarioSolicitado));
            setSalarioSolicitado(
              Number(salarioSolicitado).toLocaleString("es-MX", {
                style: "currency",
                currency: "MXN",
                minimumFractionDigits: 2,
              })
            );
          } else {
            setValorNumerico(null);
            setSalarioSolicitado("");
          }

          const empleadoEncontrado = empleados.find(
            (emp) => Number(emp.numero) === Number(numero)
          );
          console.log("empleadoEncontrado:", empleadoEncontrado);

          if (empleadoEncontrado) {
            setEmpleado(empleadoEncontrado);
            console.log("Empleado encontrado:", empleadoEncontrado);
          } else {
            console.warn("Empleado no encontrado en la lista");
          }
        } catch (error) {
          console.error("Error al cargar la falta:", error);
        }
      }
    };

    if (empleados.length > 0 && idRegistro) {
      fetchFalta();

      //cargarFalta(); // extrae el código de arriba en una función
    }
  }, [empleados, idRegistro]);

  const handleSubmit = async () => {
    if (!empleado) {
      // setErrMsg("Indique el empleado para asignar el cambio de salario.");
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Indique el empleado para asignar el cambio de salario.",
        life: 3000,
      });
      return;
    }
    if (!fechaAplicacion) {
      //setErrMsg("Ingrese la fecha de aplicacion.");
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Ingrese la fecha de aplicacion.",
        life: 3000,
      });
      return;
    }
    

    const data = {
      empleado,
      fechaAplicacion,
      salarioSolicitado: valorNumerico,
      salarioActual: empleado.PBD,
      observaciones,
      idNomina: selectedNomina.idNomina,
      periodo: `${
        selectedNomina.YearPeriodo
      }-${selectedNomina.PeriodoActual.toString().padStart(2, "0")}`,
    };
    try {
      const response = idRegistro
        ? await axiosPrivate.put(`/NOM/cambio-salario/${idRegistro}`, data)
        : await axiosPrivate.post("NOM/cambio-salario", data);
      console.log("CambioSalario response:", response.data);
      if (!idRegistro) {
        setEmpleado(null);
        setSalarioSolicitado("");
      }

      setShow(false);
      setMensaje(response?.data.msg);
      toast.current.show({
        severity: "success",
        summary: "Éxito",
        detail: response?.data.msg,
        life: 3000,
      });
    } catch (err) {
      console.error(err);
      //setErrMsg("Error al registrar el cambio de salario.");
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error al registrar el cambio de salario.",
        life: 3000,
      });
    }
  };
  const [observaciones, setObservaciones] = useState("");
  const [fechaAplicacion, setFechaAplicacion] = useState([]);

  return (
    <div className="p-4">
      <Toast ref={toast} />
      <h2 className="mb-4">Solicitudes de cambio de salario</h2>
      <div className="mb-3 flex justify-content-between">
        <Button
          label="Regresar"
          icon="pi pi-arrow-left"
          className="p-button-secondary"
          onClick={handleBack}
        />
        <Button
          label="Ver registros"
          icon="pi pi-list"
          className="p-button-info"
          onClick={() => navigate("/cambio-salario/listado")}
        />
      </div>
      {/* {errMsg && <small className="p-error">{errMsg}</small>} */}

      <div className="p-fluid p-formgrid grid">
        <div className="field col-12 md:col-6">
          <label htmlFor="empleado">Empleado</label>
          <Dropdown
            id="empleado"
            value={empleado}
            options={empleados}
            onChange={(e) => setEmpleado(e.value)}
            optionLabel="label"
            placeholder="Seleccione un empleado"
            filter
            showClear
          />
        </div>
        {true && (
          <>
            {/* <div className="field col-12 md:col-3">
              <label>Salario diario actual</label>
              <InputText
                value={`$${empleado?.PBD.toLocaleString() ?? 0}`}
                readOnly
              />
            </div> */}
            {/* <div className="field col-12 md:col-3">
        <label>Salario mensual</label>
        <InputText value={`$${empleado.SalarioDiario.toLocaleString()}`} disabled />
      </div> */}
          </>
        )}
        <div className="field col-12 md:col-6">
          <label htmlFor="salario">Salario diario solicitado</label>
          <InputText
            id="salario"
            value={salarioSolicitado}
            onChange={(e) => {
              // Permitir escribir libremente números con punto decimal
              const raw = e.target.value.replace(/[^0-9.]/g, "");
              setSalarioSolicitado(raw);

              const parsed = parseFloat(raw);
              setValorNumerico(isNaN(parsed) ? null : parsed);
            }}
            onBlur={() => {
              if (!isNaN(valorNumerico) && valorNumerico !== null) {
                setSalarioSolicitado(
                  valorNumerico.toLocaleString("es-MX", {
                    style: "currency",
                    currency: "MXN",
                    minimumFractionDigits: 2,
                  })
                );
              }
            }}
            onFocus={() => {
              // Al enfocar el campo, mostrar el número sin formato para que sea editable
              if (!isNaN(valorNumerico) && valorNumerico !== null) {
                setSalarioSolicitado(valorNumerico.toString());
              }
            }}
            placeholder="$0.00"
          />
        </div>

        <div className="field col-12 md:col-6">
          <label htmlFor="fecha">Fecha de aplicacion</label>
          <Calendar
            id="fecha"
            value={fechaAplicacion}
            onChange={(e) => setFechaAplicacion(e.value)}
            selectionMode="single"
            readOnlyInput
            dateFormat="dd/mm/yy"
            showButtonBar
            className="w-full mb-3"
            minDate={fechaInicial} // opcional: calculado con misma lógica
            maxDate={fechaFinal}
          />
        </div>

        <div className="field col-12 md:col-6">
          <label htmlFor="valor">Observaciones</label>
          <InputTextarea
            value={observaciones}
            onChange={(e) => setObservaciones(e.target.value)}
            rows={5}
            cols={30}
          />
        </div>

        <div className="field col-12">
          <Button
            label="Registrar"
            icon="pi pi-check"
            onClick={() => {
              if (!validarFechaModulo("cambios Salario", fechaAplicacion)) {
      //setErrMsg("La fecha de aplicación no está permitida por configuración.");
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "La fecha de aplicación no está permitida por configuración.",
        life: 3000,
      });
      return;
    }
              setShow(true)
            }}
          />
        </div>
      </div>

      <Dialog
        header="Confirmación"
        visible={show}
        style={{ width: "50vw" }}
        modal
        onHide={() => setShow(false)}
      >
        <p>¿Está seguro que desea registrar el cambio de salario?</p>
        <div className="flex justify-content-end gap-2 mt-4">
          <Button
            label="Cancelar"
            icon="pi pi-times"
            className="p-button-text"
            onClick={() => setShow(false)}
          />
          <Button
            label="Confirmar"
            icon="pi pi-check"
            autoFocus
            onClick={handleSubmit}
          />
        </div>
      </Dialog>
    </div>
  );
};

export default CambioSalario;
